import { z } from 'zod';

export const CANNED_VISIBILITIES = ['public', 'internal'] as const;
export const CannedVisibilitySchema = z.enum(CANNED_VISIBILITIES);
export type CannedVisibility = z.infer<typeof CannedVisibilitySchema>;

export const CANNED_BODY_MAX_LENGTH = 20_000;

/**
 * Comment template with placeholders (`{{ticket.key}}`, `{{requester.name}}`); resolved
 * where the text is used (comments in Bolt 5, notifications in Bolt 8). Tenant-wide when
 * `projectId` is null (ADR-0013 §3).
 */
export const CannedResponseSchema = z.object({
  id: z.uuid(),
  projectId: z.uuid().nullable(),
  name: z.string().min(1).max(80),
  body: z.string().min(1).max(CANNED_BODY_MAX_LENGTH),
  visibility: CannedVisibilitySchema,
  position: z.int().min(0),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type CannedResponse = z.infer<typeof CannedResponseSchema>;

export const CreateCannedResponseSchema = z.strictObject({
  projectId: z.uuid().nullable().default(null),
  name: z.string().min(1).max(80),
  body: z.string().min(1).max(CANNED_BODY_MAX_LENGTH),
  visibility: CannedVisibilitySchema.default('public'),
  position: z.int().min(0).default(0),
});
export type CreateCannedResponse = z.infer<typeof CreateCannedResponseSchema>;

export const UpdateCannedResponseSchema = z
  .strictObject({
    name: z.string().min(1).max(80),
    body: z.string().min(1).max(CANNED_BODY_MAX_LENGTH),
    visibility: CannedVisibilitySchema,
    position: z.int().min(0),
  })
  .partial();
export type UpdateCannedResponse = z.infer<typeof UpdateCannedResponseSchema>;

/** `GET /canned-responses?projectId=`. */
export const CannedResponseListQuerySchema = z.object({
  projectId: z.uuid().optional(),
});
export type CannedResponseListQuery = z.infer<typeof CannedResponseListQuerySchema>;
